var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ui-select" },
    [
      _c(
        "select",
        {
          staticClass: "f-input",
          domProps: { value: _vm.value },
          on: {
            change: function($event) {
              return _vm.$emit("change", $event.target.value)
            }
          }
        },
        _vm._l(_vm.options, function(option) {
          return _c("option", { domProps: { value: option.value || option } }, [
            _vm._v(_vm._s(option.label || option))
          ])
        }),
        0
      ),
      _vm._v(" "),
      _c("icon-dropdown")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }